// import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import { tableColumnTypes } from "../../tableColumnTypes";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import TopicManagementIcon from "../../../components/Common/SvgIcons/OrganizeIcons/TopicManagementIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { addNewTopic } from "./addNewTopic";
import { addGroupTopic } from "./addGroupTopic";
import { FormattedMessage } from "react-intl";

export let topicManagement = {
  name: <FormattedMessage id="TOPICMANAGEMENT_TEXT" />,
  path: (tenantName) => `/${tenantName}/organize/topicManagement`,
  icon: TopicManagementIcon,
  searchPlaceHolder: "Search topic by name",
  searchTopicPlaceHolder: "Search subtopic by name or tag",
  columns: (navigate, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="NAME_TEXT" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "IsPublished",
      value: (row) =>
        row.IsPublished == true ? (
          <FormattedMessage id="MYCLASS_PUBLISHED" />
        ) : (
          <FormattedMessage id="Not Published" />
        ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="CREATED_ON_TXT" />,
      fieldName: "CreatedOn",
      value: (row) => row.CreatedOn,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="CREATED_BY" />,
      fieldName: "CreatedBy",
      value: (row) => row.CreatedBy,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="RECALL_ACTION" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip
            content={<FormattedMessage id="MYCLASS_EDIT" />}
            direction={"bottom"}
          >
            <span
              onClick={() =>
                navigate(`${addGroupTopic.editpath(tenantName)}/${row.Id}`)
              }
            >
              <EditIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
  topicColumns: (
    handleDelete,
    handleEdit,
    handlePreview,
    navigate,
    tenantName
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="NAME_TEXT" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "IsPublished",
      value: (row) =>
        row.IsPublished == true ? (
          <FormattedMessage id="MYCLASS_PUBLISHED" />
        ) : (
          <FormattedMessage id="Not Published" />
        ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="CREATED_ON_TXT" />,
      fieldName: "CreatedOn",
      value: (row) => row.CreatedOn,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="CREATED_BY" />,
      fieldName: "CreatedBy",
      value: (row) => row.FirstName + " " + row.LastName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="RECALL_ACTION" />,
      fieldName: "",
      value: (row) => (
        <>
          {row.IsCreatedByme === true && (
            <Tooltip content={<FormattedMessage id="MYCLASS_DELETE" />} direction={"bottom"}>
              <span onClick={() => handleDelete(row.TopicId)}>
                <DeleteIcon />
              </span>
            </Tooltip>
          )}
          <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction={"bottom"}>
            <span
              onClick={() =>
                navigate(`${addNewTopic.editpath(tenantName)}/${row.TopicId}`)
              }
            >
              <EditIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="P_REVIEW" />} direction={"bottom"}>
            <span
              onClick={() =>
                handlePreview(row.TopicId, row.FirstName, row.LastName)
              }
            >
              <ViewIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
